module.exports = __webpack_public_path__ + "c78d5d2c71a800a4cab68f13307fafce.svg";